import { ref } from 'vue'

export function useLightbox() {
  const showLightbox = ref(false)
  const currentLightboxImage = ref('')

  const openLightbox = (src) => {
    currentLightboxImage.value = src
    showLightbox.value = true
  }

  const closeLightbox = () => {
    showLightbox.value = false
    currentLightboxImage.value = ''
  }

  const handleBodyClick = (event) => {
    if (event.target.tagName === 'IMG') {
      openLightbox(event.target.src)
    }
  }

  return {
    showLightbox,
    currentLightboxImage,
    openLightbox,
    closeLightbox,
    handleBodyClick
  }
}
